import { MenuSub } from '@/components/menu';
import { MegaMenuSubDropdown } from './components';
const MegaMenuSubRefferal = items => {
  const referralItem = items.find(
    item => item.title === 'Referrals ' || item.title === 'Referrals'
  );
  ;
  return <MenuSub className="menu-default py-2.5 lg:w-[225px]">
    {referralItem.children && MegaMenuSubDropdown(referralItem.children)}
  </MenuSub>;
};
export { MegaMenuSubRefferal };